/**
 * 微博编辑器，只在iwo的融合编辑器场景中使用
 */
'use strict';
angular.module('weiboEditPageModule', ['weiboEditPageRouterModule']).controller('weiboEditPageCtrl', [
    '$scope',
    '$state',
    'jsonArrayToStringService',
    'initVersionService',
    'sensitiveWordCheckService',
    '$validation',
    '$timeout',
    'modalDialog',
    'editingCenterService',
    'trsHttpService',
    'localStorageService',
    'beforeonload',
    '$stateParams',
    '$q',
    'editingCenterWeiBoService',
    'iWoService',
    '$compile',
    '$element',
    'editCenUploadVideoForXjService',
    'loginService',
    'globleParamsSet',
    '$interval',
    'editingMediatype',
    'trsspliceString',
    'weiboApiParams',
    'weiboApiService',
    function (
        $scope,
        $state,
        jsonArrayToStringService,
        initVersionService,
        sensitiveWordCheckService,
        $validation,
        $timeout,
        modalDialog,
        editingCenterService,
        trsHttpService,
        localStorageService,
        beforeonload,
        $stateParams,
        $q,
        editingCenterWeiBoService,
        iWoService,
        $compile,
        $element,
        editCenUploadVideoForXjService,
        loginService,
        globleParamsSet,
        $interval,
        editingMediatype,
        trsspliceString,
        weiboApiParams,
        weiboApiService
    ) {
        initStatus();
        editingCenterWeiBoService.addFuture($scope, ['sendmessage']);

        /**
		 * [initStatus 初始化状态]
		 *
		 * @return  {[type]}
		 *   [return description]
		 */
        function initStatus() {
            $scope.status = {
                switch: 'manuscriptInfo', // 默认选中稿件信息
                iwoMetadataId: $stateParams.iwometadataid == undefined ? 0 : $stateParams.iwometadataid,
                isCheckSensitiveWords: false,
                addVideoUrlShow: false,
                addVideoDisabled: false,
                uploadVideoShow: false,
                mediaType: editingMediatype.app,
                weibometadataid: $state.params.wbmetadataid,
                pics: [],
                isShowMap: false,
                dragging: false,
                curOverIndex: -1,
            };
            $scope.data = {
                newsFormError: [],
                userName: '',
                version: [],
                copyVersion: [],
                path: {
                    '-1': 'editingCenterFusionPersonalVersionTime',
                    '1': 'editingCenterAppPersonalVersionTime',
                    '2': 'editingCenterWebsitePersonalVersionTime',
                    '3': 'editingCenterPaperPersonalVersionTime',
                    '4': 'editingCenterWeixinPersonalVersionTime',
                },
                videoUrl: '',
                videoShortUrl: '',
                baiduLocation: {
                    placeName: '',
                    lng: '',
                    lat: '',
                }
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };

            // 云视视频上传对象
            $scope.uploader = {
                example: '',
                progress: 0,
                fastVideoTimer: '',
                canNotPlay: false,
                fastVideoInfo: {}, // 视频快编信息
                uploaderOptions: angular.extend({}, editCenUploadVideoForXjService.singleVideoOption), // 上传配置项
            };
            emitCloseWindow();
            $scope.editFlag = {
                media: 'iwo', 
                docType: 'weibo',
            };
        }

        /**
         * [initData description] 初始化数据
         * @param  {[type]} dealWithListFun [description] 初始化后数据外部处理回调函数
         * @return {[type]}                 [description]
         */
        $scope.initData = function (dealWithListFun) {
            var deffer = $q.defer();
            if (angular.isDefined($stateParams.wbmetadataid)) {
                initEditData(dealWithListFun).then(function () {
                    deffer.resolve();
                });
            } else {
                initNewData(dealWithListFun).then(function () {
                    if ($scope.list.VIDEOREL && $scope.list.VIDEOREL.length) {
                        $scope.uploader = {
                            example: '',
                            progress: 0,
                            fastVideoTimer: '',
                            canNotPlay: false,
                            fastVideoInfo: {}, // 视频快编信息
                            uploaderOptions: angular.extend({}, editCenUploadVideoForXjService.singleVideoOption), // 上传配置项
                        };
                        examineVideo();
                    }
                    deffer.resolve();
                });
            }
            return deffer.promise;
        };

        /**
         * [updateCKSelection description]trsCheckBox的回调函数
         * @param  {[str]} attribute [description]需要改变的属性
         * @return {[type]}           [description]
         */
        $scope.updateCKSelection = function (attribute) {
            $scope.list[attribute] = $scope.list[attribute] == '0' ? '1' : '0';
        };


        /**
         * [initEditData description] 编辑数据
         * @param   {[type]}  dealWithListFun  [dealWithListFun description]
         * @return  {[type]}                   [return description]
         */
        function initEditData(dealWithListFun) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_fusionmicroblog',
                methodname: 'getScmVirtualNewsDoc',
                SourceDocId: $stateParams.iwometadataid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.list = data;
                $scope.data.remarks = data.REMARKS;
                $scope.status.pics = getPictures();
                if ($scope.list.VIDEOREL && $scope.list.VIDEOREL.length) {
                    examineVideo();
                }
                getVersion();
                loadDirective();
                initDocgenre(data);
                initLocation();
                if (angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [loadFgd description] 加载发稿单
         * @return {[type]} [description]
         */
        $scope.loadFgd = function () {
            var draftList =
                '<editor-dir list="list" meta-data-id="{{status.iwoMetadataId}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                '<editor-auth-dir originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0" author="list.FGD_AUTHINFO"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
        };

        /**
         * [getVersion description] 获取流程记录
         * @return {[type]} [description]
         */
        function getVersion() {
            var deffer = $q.defer();
            editingCenterService.getEditVersionTime($scope.data.sourceDocId || $stateParams.iwometadataid, $scope.page, $scope.data.copyVersion).then(
                function (data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    deffer.resolve();
                },
                function () {
                    deffer.resolve();
                }
            );
            return deffer.promise;
        }

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * [initNewData description] 新建数据
         * @param   {[type]}  dealWithListFun  [dealWithListFun description]
         * @return  {[type]}                   [return description]
         */
        function initNewData(dealWithListFun) {
            var deffer = $q.defer();
            $scope.list = editingCenterWeiBoService.initWeiboData();
            initDocgenre();
            loadDirective();
            if (angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            deffer.resolve();
            return deffer.promise;
        }

        /**
         * [loadDirective description] 动态加载发稿单等指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            if ($stateParams.issave !== undefined && $stateParams.issave !== '0') {return;} // 用于融合编辑器的虚拟表单校验，虚拟表单检验不需要加载编辑器
            var supportCreation =
                '<support-creation parent-status="status" media-type="{{\'5\'}}" is-check-sensitive-words="status.isCheckSensitiveWords" list="list"></support-creation>';
            supportCreation = $compile(supportCreation)($scope);
            $element.find('supportcreation').append(supportCreation);
        }

        /**
         * [initDocgenre description] 初始化稿件体裁
         * @param   {[type]}  obj  [obj description]
         * @return  {[type]}       [return description]
         */
        function initDocgenre(obj) {
            iWoService.initData().then(function (data) {
                $scope.docgenre = data.DocGenre;
                $scope.list.DOCGENRE = angular.isDefined(obj) ? obj.DOCGENRE : angular.copy($scope.docgenre[0]);
            });
        }

        /**
         * [addEmoji description] 添加表情
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.addEmoji = function (item) {
            var $t = $element.find('.weibo_editor textarea')[0];
            var startPos = $t.selectionStart;
            var endPos = $t.selectionEnd;
            $scope.list.CONTENT =
                $scope.list.CONTENT.substring(0, startPos) + item.value + $scope.list.CONTENT.substring(endPos, $scope.list.CONTENT.length);

            $timeout(function () {
                $t.selectionStart = $t.selectionEnd = startPos + item.value.length;
                $t.focus();
            });
        };

        /**
         * [addTopic description] 添加话题
         * @return  {[type]}  [return description]
         */
        $scope.addTopic = function () {
            var $t = $element.find('.weibo_editor textarea')[0];
            var startPos = $t.selectionStart;
            var endPos = $t.selectionEnd;
            $scope.list.CONTENT =
                $scope.list.CONTENT.substring(0, startPos) + '##' + $scope.list.CONTENT.substring(endPos, $scope.list.CONTENT.length);

            $timeout(function () {
                $t.selectionStart = $t.selectionEnd = startPos + 1;
                $t.focus();
            });
        };

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.weiboForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = !$scope.status.newsFormError ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length !== errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; // 返回
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            // window.onbeforeunload = function () {
            //     localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $stateParams.iwometadataid }));
            // };
            editingCenterService.allAppCloseWindow($scope, {typeName: 'iwo', saveLocal: false});
        }

        /**
         * [dealAttribute description] 处理参数
         * @return {[type]} [description]
         */
        function dealAttribute() {
            let list = angular.copy($scope.list);
            delete list.ISNOPAYMENT;
            delete list.FGD_EDITINFO;
            delete list.FGD_AUTHINFO;
            delete list.DOCGENRE;
            delete list.NEWSSOURCES;
            list.FUSIONSCMID = $stateParams.wbmetadataid || '0';
            list.serviceid = 'mlf_fusionmicroblog';
            list.methodname = 'saveScmVirtualNewsDoc';
            list.SourceDocId = $scope.data.sourceDocId || $stateParams.iwometadataid;
            list = jsonArrayToStringService.jsonArrayToString(list);
            return list;
        }

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            var path = $scope.data.path[item.MEDIATYPE];
            geRelatedversion($stateParams.iwometadataid, item.VERSIONNUM).then(function (data) {
                var params = {
                    // 融合
                    metadataid: $stateParams.iwometadataid,
                    iwoobjectversionid: item.OBJECTVERSIONID,
                    wzobjectversionid: angular.isDefined(data.web) ? data.web.objversionId : '',
                    bzobjectversionid: angular.isDefined(data.paper) ? data.paper.objversionId : '',
                    appobjectversionid: angular.isDefined(data.app) ? data.app.objversionId : '',
                    wxobjectversionid: angular.isDefined(data.wechat) ? data.wechat.objversionId : '',
                    versionum: item.VERSIONNUM,
                };
                item.url = $state.href(path, params);
                var url = item.url;
                window.open(url);
            });
        };

        /**
         * [geRelatedversion description] 融合稿获取关联流程版本
         * @param  {[type]} MetaDataId [description]
         * @param  {[type]} num        [description]
         * @return {[type]}            [description]
         */
        function geRelatedversion(MetaDataId, num) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_fusionmyrelease',
                methodname: 'getObjversionByDoc',
                METADATAID: MetaDataId,
                VersionNum: num,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [save description] 保存
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.save = function (type) {
            var deffer = $q.defer();
            $scope.list.PICTURE = trsspliceString.spliceString($scope.status.pics, 'imgName', ',');
            if ($scope.list.CONTENT.length > 5000 && $scope.list.PICTURE && $scope.list.PICTURE.length > 0) {
                modalDialog.alertType('', '长文本微博不能附带图片发布！请重新编辑', 'error', 'confirm');
                deffer.reject();
            } else {
                $validation.validate($scope.weiboForm.authorForm);
                $validation
                    .validate($scope.weiboForm)
                    .success(function () {
                        modalDialog.isSecretInformation(
                            $stateParams.wzmetadataid,
                            function () {
                                sensitiveWordCheckService.sensitiveWords($scope).then(
                                    function (sensitiveWords) {
                                        $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords && sensitiveWords.length > 0 ? 1 : 0;
                                        $scope.list.SENSITIVEWORDS = sensitiveWords;
                                        $scope.weiboForm.$setPristine();
                                        var list = dealAttribute();
                                        list.CONTENT = list.CONTENT.replace(/\n/g, '&#10;');
                                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                            function (data) {
                                                $scope.list.FUSIONSCMID = data.METADATAID.replace(/\"/g, '');
                                                $stateParams.wbmetadataid = angular.isDefined($stateParams.wbmetadataid)
                                                    ? $stateParams.wbmetadataid
                                                    : $scope.list.FUSIONSCMID;
                                                beforeonload.refresh($scope);
                                                if ($scope.$root.cureditpage === undefined || $scope.$root.cureditpage === 'wbeditpage') {
                                                    // 重写日志
                                                    getVersion();
                                                }
                                                deffer.resolve();
                                            },
                                            function (data) {
                                                deffer.reject(data);
                                            }
                                        );
                                    },
                                    function () {
                                        deffer.reject();
                                    }
                                );
                            },
                            function () {
                                deffer.reject();
                            },
                            true
                        );
                    })
                    .error(function () {
                        editingCenterService.checkSaveError($scope.weiboForm, $element, $scope); // 定位输入错的表单位置
                        deffer.reject({ plat: '微博'});
                    });
            }
            return deffer.promise;
        };

        $scope.addVideoUrl = function () {
            $scope.status.addVideoDisabled = true;
            let sourceUrl = $scope.data.videoUrl;
            getVideoShortUrl(sourceUrl).then(function (data) {
                $scope.data.videoShortUrl = data.SHORTURL || sourceUrl;
                $scope.list.CONTENT += $scope.data.videoShortUrl;
                $scope.status.addVideoUrlShow = false;
            });
        };

        $scope.deleteVideoUrl = function (value) {
            if ($scope.data.videoUrl === '') {
                $scope.status.addVideoUrlShow = false;
            }
            $scope.data.videoUrl = '';
            let str;
            if (value) {
                str = value;
            } else {
                str = $scope.data.videoShortUrl;
            }
            $scope.status.addVideoDisabled = false;
            $scope.list.CONTENT = $scope.list.CONTENT.replace(str, '');
        };

        // $scope.$watch('data.videoUrl',function(newValue,oldValue) {
        //     if(oldValue !== "" && $scope.status.addVideoDisabled){
        //         $scope.deleteVideoUrl($scope.data.videoShortUrl);
        //     }
        // });
        /**
         * [getVideoShortUrl description] 获得短视频地址
         * @param   {[type]}  url  [url description]
         * @return  {[type]}       [return description]
         */
        function getVideoShortUrl(url) {
            var deferred = $q.defer();
            let params = angular.extend({}, weiboApiParams.shortURLParams, {
                URL: encodeURIComponent(url),
            });
            $scope.loadingPromise = weiboApiService.getShortURL(params).then(
                function (data) {
                    deferred.resolve(data);
                },
                function (result) {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        /**
         * [pictureShowAndHide description] 图片上传窗口的显示隐藏
         * @return  {[type]}  [return description]
         */
        $scope.pictureShowAndHide = function () {
            if (!$scope.status.uploadPicOpend) {
                // 打开图片上传窗口时查看是否存在本地视频
                if ($scope.list.VIDEOREL && $scope.list.VIDEOREL.length) {
                    modalDialog.alertType('温馨提示', '不能同时发布图片和视频，是否放弃发布本地视频？', 'ask', true, function () {
                        $scope.deleteVideo();
                        $scope.status.uploadPicOpend = true;
                        $scope.status.uploadVideoShow = false;
                        $scope.status.addVideoUrlShow = false;
                    });
                    // 打开图片上传窗口时查看是否存在网络视频
                } else if ($scope.data.videoUrl) {
                    modalDialog.alertType('温馨提示', '不能同时发布图片和视频，是否放弃发布网络视频？', 'ask', true, function () {
                        $scope.deleteVideoUrl();
                        $scope.status.uploadPicOpend = true;
                        $scope.status.uploadVideoShow = false;
                        $scope.status.addVideoUrlShow = false;
                    });
                } else {
                    $scope.status.uploadPicOpend = true;
                    $scope.status.uploadVideoShow = false;
                    $scope.status.addVideoUrlShow = false;
                }
            } else {
                $scope.status.uploadPicOpend = false;
            }
        };

        /**
         * [videoShowAndHide description] 视频上传窗口隐藏显示
         * @return  {[type]}  [return description]
         */
        $scope.videoShowAndHide = function () {
            $scope.status.uploadPicOpend = false;
            if (!$scope.status.addVideoUrlShow) {
                if ($scope.list.PICTURE && $scope.list.PICTURE.length > 0) {
                    modalDialog.alertType('温馨提示', '不能同时发布图片和视频，是否放弃发布图片？', 'ask', true, function () {
                        $scope.list.PICTURE = '';
                        $scope.status.uploadPicOpend = false;
                        $scope.status.addVideoUrlShow = true;
                        $scope.status.uploadVideoShow = false;
                    });
                } else {
                    $scope.status.uploadPicOpend = false;
                    $scope.status.addVideoUrlShow = true;
                    $scope.status.uploadVideoShow = false;
                }
            } else {
                $scope.status.addVideoUrlShow = false;
            }
        };

        /**
         * [videoLocalShowAndHide description] 本地视频上传窗口隐藏显示
         * @return  {[type]}  [return description]
         */
        $scope.videoLocalShowAndHide = function () {
            $scope.status.uploadPicOpend = false;
            if (!$scope.status.uploadVideoShow) {
                if ($scope.list.PICTURE && $scope.list.PICTURE.length > 0) {
                    modalDialog.alertType('温馨提示', '不能同时发布图片和视频，是否放弃发布图片？', 'ask', true, function () {
                        $scope.list.PICTURE = '';
                        $scope.status.uploadPicOpend = false;
                        $scope.status.uploadVideoShow = true;
                        $scope.status.addVideoUrlShow = false;
                    });
                } else {
                    $scope.status.uploadPicOpend = false;
                    $scope.status.uploadVideoShow = true;
                    $scope.status.addVideoUrlShow = false;
                }
            } else {
                $scope.status.uploadVideoShow = false;
            }
        };

        /** ************上传视频开始*******************/
        /**
         * [startInterval description]设置定时器
         * @return {[type]} [description]
         */
        function startInterval() {
            $interval.cancel($scope.uploader.fastVideoTimer);
            $scope.uploader.fastVideoTimer = $interval(function () {
                getVideoInfo();
            }, editCenUploadVideoForXjService.videoPollInterval);
        }

        /**
         * [examineVideo description]视频检查
         * @return {[type]} [description]
         */
        function examineVideo() {
            var videoInfo = localStorageService.get('videoUploadFusionWeiboInfo');
            editCenUploadVideoForXjService.exampleVideo(videoInfo, $scope.list, $state.params.baijiahaoarticleid).then(
                function (data) {
                    $scope.list.VIDEOREL[0].AUDIOVIDEOID = data[0]; // 再次回写ID
                    getVideoInfo();
                },
                function () {
                    getVideoInfo();
                }
            );
        }

        /**
         * [getVideoInfo description]获得视频详情
         * @return {[type]} [description]
         */
        function getVideoInfo() {
            editCenUploadVideoForXjService.getVideoMark($scope.list.VIDEOREL[0]).then(function (data) {
                $scope.uploader.fastVideoInfo = data;
                $scope.uploader.fastVideoInfo.status = editCenUploadVideoForXjService.videoDraftStatus[data.status];
                $scope.list.VIDEOREL[0].URL = data.videoUrl; // 回填URL
                $scope.list.VIDEOREL[0].ThumbImg = data.ThumbImg;
                if ($scope.uploader.fastVideoInfo.status === '转码中' || $scope.uploader.fastVideoInfo.status === '快编中') {
                    if (!$scope.data.fastVideoTimer) {startInterval();}
                } else {
                    $interval.cancel($scope.uploader.fastVideoTimer);
                }
            });
        }

        /**
         * [uploadTest description]视频上传
         * @return {[type]} [description]
         */
        $scope.uploadTest = function () {
            var upload = $scope.uploader.example();
            $scope.uploader.canNotPlay = false;
            upload.on('success', function (file) {
                uploadAsync(file);
                if (file.type !== 'video/mp4') {
                    $scope.uploader.canNotPlay = true;
                }
            });
            upload.on('progress', function (obj) {
                $timeout(function () {
                    $scope.uploader.progress = obj.progress.toFixed(2) + '%';
                });
            });
        };

        /**
         * [deleteVideo description] 删除视频预览
         * @return {[type]} [description]
         */
        $scope.deleteVideo = function () {
            if ($scope.uploader.fastVideoTimer) {
                // 避免存在失败的情况还在轮训
                $interval.cancel($scope.uploader.fastVideoTimer);
            }
            $scope.list.VIDEOREL = [];
        };

        /**
         * [editVideo description]快编视频
         * @return {[type]} [description]
         */
        $scope.fastEditVideo = function () {
            $scope.loadingPromise = editCenUploadVideoForXjService.editVideo($scope.list).then(function (data) {
                startInterval();
                storgeVideoInfo(false, data); // 快编后等于又一次上传保存
                $scope.list.VIDEOREL[0].AUDIOVIDEOID = data.datas.videoid; // 回写ID
                window.open(data.datas.qediturl); // 打开快编页面
            });
        };

        /**
         * [cancelEditVideo description]取消快编
         * @return {[type]} [description]
         */
        $scope.cancelEditVideo = function () {
            $scope.loadingPromise = editCenUploadVideoForXjService.cancelEditVideo($scope.list).then(function (data) {
                $scope.list.VIDEOREL[0].AUDIOVIDEOID = data.videoId; // 回写ID
                $scope.list.VIDEOREL[0].URL = data.videoUrl;
                $scope.uploader.fastVideoInfo.status = editCenUploadVideoForXjService.videoDraftStatus[data.status];
                $timeout.cancel($scope.uploader.fastVideoTimer);
            });
        };

        /**
         * [storgeVideoInfo description]存储当前稿件视频信息
         * @param  {Boolean} isSave    [description]是否保存
         * @param  {[type]}  videoInfo [description]
         * @return {[type]}            [description]
         */
        function storgeVideoInfo(isSave, videoInfo) {
            if (!$state.params.baijiahaoarticleid) {
                // 只有编辑页才存储
                return;
            }
            var storage = localStorageService.get('videoUploadFusionWeiboInfo') || {};
            if (isSave) {
                delete storage[$state.params.baijiahaoarticleid]; // 保存后删除记录
            } else {
                storage[$state.params.baijiahaoarticleid || 0] = [videoInfo.datas.videoid]; // 不保存的话存储状态
            }
            localStorageService.set('videoUploadFusionWeiboInfo', storage); // 记录上传后的视频信息
        }

        /**
         * [uploadAsync description]上传后的异步操作
         * @param  {[obj]} file [description]上传的文件信息
         * @return {[type]}     [description]
         */
        function uploadAsync(file) {
            loginService
                .getCurrLoginUser()
                .then(function (user) {
                    return globleParamsSet.getTokenService(user.TENANTID);
                })
                .then(function (tokenInfo) {
                    return editCenUploadVideoForXjService.registerVideo(file, tokenInfo.tenantId, tokenInfo.token);
                })
                .then(
                    function (videoInfo) {
                        storgeVideoInfo(false, videoInfo);
                        $scope.list.VIDEOREL = [];
                        $scope.uploader.progress = 0;
                        $timeout(function () {
                            $scope.uploader.fastVideoInfo.status = '转码中';
                            $scope.list.VIDEOREL.push({
                                AUDIOVIDEOID: videoInfo.datas.videoid,
                                URL: file.path,
                                REMARKS: '',
                                PLATFORMFLAG: 'BDVideoObject',
                                ThumbImg: videoInfo.datas.ThumbImg,
                            });
                        });
                        startInterval(); // 上传成功后就轮训
                    },
                    function () {
                        $scope.uploader.progress = 0;
                        modalDialog.saveModel('上传失败', '请重新上传', 'warning');
                    }
                );
        }

        /**
         * [uploadVideo 上传视频]
         *
         * @return  {[type]}
         *   [return description]
         */
        $scope.uploadVideo = function () {
            if ($scope.list.PICTURE && $scope.list.PICTURE.length > 0) {
                modalDialog.alertType('温馨提示', '不能同时发布图片和视频，是否放弃发布图片？', 'ask', true, function () {
                    $scope.list.PICTURE = '';
                    $scope.status.pics = [];
                    uploadVideo();
                });
            } else {
                uploadVideo();
            }
        };

        /**
         * [uploadVideo 素材库方式上传视频]
         *
         * @return  {[type]}
         *   [return description]
         */
        function uploadVideo() {
            let options = {
                list: $scope.list,
            };
            editingCenterWeiBoService.uploadVideo(options, function (result) {
                $scope.list = result.list;
                $scope.uploader = result.uploader;
                $scope.data.videoUrl = result.videoUrl;
                if ($scope.videoUrl !== '') {
                    $scope.addVideoUrl();
                }
            });
        }

        /** ************上传视频结束*******************/

        /** 上传图片弹窗开始 */

        /**
         * [uploadPicture 上传图片弹窗]
         *
         * @return  {[type]}
         *   [return description]
         */
        function uploadPicture() {
            // 对接媒资库
            let options = {
                resourceType: '0',
                isMulti: true,
                maxSize: 18 - $scope.status.pics.length // 微博最多9张图片
            };
            editingCenterService.mediaSelector(options).then(function(result) {
                var picList = $scope.list.PICTURE ? $scope.list.PICTURE.split(',') : [];
                for (var l = 0; l < result.list.length; l++) {
                    // 我的图片已经选中的
                    picList.push(result.list[l].resourceurl);
                }
                $scope.list.PICTURE = picList.join(',');
                $scope.status.pics = getPictures();
            });
        }

        /**
         * [getPictures 获取图片数组]
         *
         * @return  {[type]}
         *   [return description]
         */
        function getPictures() {
            return ($scope.list.PICTURE === '' || $scope.list.PICTURE === undefined ? [] : $scope.list.PICTURE.split(',')).map((item, index) => ({
                imgName: item,
                // imgSrc: '/wcm/app/scm/file/read_image.jsp?FileName=' + item,
                imgSrc: item.indexOf('http') !== -1 ? item : '/wcm/app/scm/file/read_image.jsp?FileName=' + item,
                overing: false,
            }));
        }

        /**
         * [uploadPicture 上传图片]
         *
         * @return  {[type]}
         *   [return description]
         */
        $scope.uploadPicture = function () {
            if ($scope.list.VIDEOREL && $scope.list.VIDEOREL.length) {
                modalDialog.alertType('温馨提示', '不能同时发布图片和视频，是否放弃发布本地视频？', 'ask', true, function () {
                    $scope.deleteVideo();
                    uploadPicture();
                });
                // 打开图片上传窗口时查看是否存在网络视频
            } else if ($scope.data.videoUrl) {
                modalDialog.alertType('温馨提示', '不能同时发布图片和视频，是否放弃发布网络视频？', 'ask', true, function () {
                    $scope.deleteVideoUrl();
                    uploadPicture();
                });
            } else {
                uploadPicture();
            }
        };

        $scope.deletePicture = function (index) {
            $scope.status.pics.splice(index, 1);
            $scope.list.PICTURE = trsspliceString.spliceString($scope.status.pics, 'imgName', ',');
        };

        /**
         * [clearBlankLine 清除正文中的空行]
         *
         * @return  {[type]}  [return description]
         */
        $scope.clearBlankLine = function() {
            let content = $scope.list.CONTENT;
            content = content.replace(/(\n[\s|\t]*\r*\n)/g, '\n');
            $scope.list.CONTENT = content;
        };

        /**
         * [confirmAddress 确认添加地点]
         *
         * @param   {[type]}  address  [address description]
         *
         * @return  {[type]}           [return description]
         */
        $scope.confirmAddress = function(address) {
            $scope.status.isShowMap = false;
            let str = `#${address}[地点]#`;
            $scope.list.CONTENT += str;
        };

        /**
         * [取消添加地点操作]
         */
        $scope.cancelAddAddress = function() {
            $scope.status.isShowMap = false;
        };

        /**
         * 触发添加地点操作
         */
        $scope.addAddress = function() {
            $scope.status.isShowMap = !$scope.status.isShowMap;
        };

        /**
         * [initLocation 初始化位置信息]
         *
         * @return  {[type]}  [return description]
         */
        function initLocation() {
            let content = $scope.list.CONTENT;
            let reg = /#.[^#]+\[\u5730\u70b9\]#/g;
            let arr = content.match(reg);
            if (arr && arr.length){
                let lastPlace = arr[arr.length - 1];
                $scope.data.baiduLocation.placeName = lastPlace.split('[')[0].replace('#', '');
            }
        }

        $scope.dropCallback = function(event, index, item, external, type, allowedType) {
            var targetIndex = $scope.status.curOverIndex - 1;
            let sourcePic = angular.copy($scope.status.pics[$scope.moveIndex]);
            let targetPic = angular.copy($scope.status.pics[targetIndex]);
            $scope.status.pics.splice(targetIndex, 1, sourcePic);
            $scope.status.pics.splice($scope.moveIndex, 1, targetPic);
            return item;
        };

        $scope.overCallback = function(evt, index) {
            if (index === $scope.status.curOverIndex) {
                return true;
            }
            if (!$(evt.target).hasClass('resize')){
                return true;
            }
            $scope.status.curOverIndex = index;
            angular.forEach($scope.status.pics, function(item) {
                item.overing = false;
            });
            $scope.status.pics[index - 1].overing = true;
            return true;
        };

        $scope.dragStart = function() {
            $scope.status.dragging = true;
        };

        $scope.dragEnd = function() {
            $scope.status.dragging = false;
            angular.forEach($scope.status.pics, function(item){
                item.overing = false;
            });
        };

        // h5拖拽结束
        $scope.getIndex = function(index) {
            $scope.moveIndex = index;
        };
    },
]);
